import { render, staticRenderFns } from "./CustomerInsuranceDetail.vue?vue&type=template&id=79dbc614&scoped=true&"
import script from "./CustomerInsuranceDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dbc614",
  null
  
)

export default component.exports